import React, { useContext, useEffect, useState } from "react";

import "../../components/CSS/Packages/package.css";

import { Table } from "react-bootstrap";
import axios from "axios";
import { Card, Modal } from "react-bootstrap";

import swal from "sweetalert";

import "./Packages.css";
import { LocationContext, WalletContext } from "../../CustomHelper/Helper";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import PaymentModal1 from "../../components/Modal/PaymentModal/PaymentModal1";
import MyVerticallyCenteredModal from "../../components/RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";

export const Packages = () => {
  const [modalShowPay, setModalShowPay] = React.useState(false);

  const { allPackages, setAllPackage, loveBundel, setLoveBundel } =
    useContext(WalletContext);
  const { userWalletHistory, setUserWalletHistory } = useContext(WalletContext);
  const { packageId, setPackageId } = useContext(WalletContext);
  const { userId, setUserId } = useContext(WalletContext);

  const [loading, setLoading] = useState(true);
  const [packageType, setPackageType] = useState();
  const [packagePrice, setPrice] = useState();
  const [baseFee, setBaseFee] = useState();

  const paymentModalStatusFun = (data) => {
    setModalShowPay(data);
  };

  const { checkRealTime, setCheckRealTime } = useContext(WalletContext);
  const { slectedCurrency, payStatus } = useContext(LocationContext);

  const [countryBaseCost, setCountryBaseCost] = useState(false);

  useEffect(() => {
    axios.get(`/api/user/packages/all`).then((res) => {
      if (res.status === 200) {
        setAllPackage(res.data.allPackages);
        setLoveBundel(res.data.reactBundel);
        setUserId(res.data.userId);
        setLoading(false);
      }
    });
  }, []);

  const handelCuntrybasePrice = (fee) => {
    return (Number(fee) * Number(slectedCurrency?.currency_value)).toFixed(0);
  };

  // useEffect(() => {
  //   setCountryBaseCost((Number(post.fee) * Number(slectedCurrency?.currency_value)).toFixed(0))

  // }, [post, slectedCurrency])

  const handlePackage = (packageId, type, price, baseFee) => {
    setPackageType(type);
    setPackageId(packageId);
    setPrice(price);
    setBaseFee(baseFee);
    handleModel();
  };

  const handleModel = () => {
    setModalShowPay(true);
  };

  const handleModelFree = (data) => {
    setModalShowPay(false);
    setPackageId(data);
    setCheckRealTime(true);

    axios.post(`/api/user/free/wallet/store/${data}/${userId}`).then((res) => {
      if (res.data.status === 200) {
        swal("Welcome", res.data.message, "success");
      }
    });
  };

  return (
    <>
      <div className="">
        <h2 className="mt-3 fw-bold activitiesBg p-2 btn w-100 text-center">
          Available Packages
        </h2>
        <div className="row">
          {loading ? (
            <SkeletonTheme baseColor="#202020" highlightColor="#444">
              <div className="row">
                {[1, 2].map((data) => (
                  <>
                    <div className="col-md-1"></div>
                    <div className="col-md-5 mb-4 ">
                      <div className="rounded">
                        <div className="bg-dark py-3 px-2 text-center">
                          <Skeleton width="60%" height={50} />
                          <Skeleton width="50%" height={40} />
                          <br />
                          <Skeleton count={6} width="70%" />
                          <br />
                          <br />
                          <Skeleton width="60%" className="" height={35} />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-5 mb-4">
                      <div className="rounded">
                        <div className="bg-dark py-3 px-2 text-center rounded">
                          <Skeleton width="60%" height={50} />
                          <Skeleton width="50%" height={40} />
                          <br />
                          <Skeleton count={6} width="70%" />
                          <br />
                          <br />
                          <Skeleton width="60%" className="" height={35} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-1"></div>
                  </>
                ))}
              </div>
            </SkeletonTheme>
          ) : (
            <>
              {allPackages?.map((data, i) => (
                <div className="col-md-6" key={i}>
                  <div
                    className="packageCard mx-auto text-center"
                    style={{ background: `${data.color_code}` }}
                  >
                    <h5 className="text-light mt-4">{data?.title}</h5>
                    <h4 className="pricePackage">
                      {handelCuntrybasePrice(data?.price) +
                        " " +
                        slectedCurrency?.symbol}{" "}
                    </h4>

                    <ul className="text-List fw-bold">
                      <li>
                        {data.club_points === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Club Points : {data.club_points}
                      </li>
                      <li>
                        {data.love_points === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Love Points : {data.love_points}
                      </li>
                      <li>
                        {data.auditions === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Auditions : {data.auditions}
                      </li>
                      <li>
                        {data.learning_session === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Learning Session : {data.learning_session}
                      </li>
                      <li>
                        {data.live_chats === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Live Chats : {data.live_chats}
                      </li>
                      <li>
                        {data.meetup === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Meetup Events : {data.meetup}
                      </li>
                      <li>
                        {data.greetings === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Greetings : {data.greetings}
                      </li>
                      <li>
                        {data.qna === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Q & A : {data.qna}
                      </li>
                    </ul>

                    {/* <button className="btnBuyNow my-4">Buy Now</button> */}

                    {data.price === 0 ? (
                      <button
                        className="btnBuyNow my-4"
                        type="button"
                        onClick={() => handleModelFree(data.id)}
                      >
                        Free
                      </button>
                    ) : (
                      <>
                        {payStatus && (
                          <button
                            className="btnBuyNow my-4"
                            type="button"
                            onClick={() =>
                              handlePackage(
                                data.id,
                                "package",
                                handelCuntrybasePrice(data.price),
                                data.price
                              )
                            }
                          >
                            Buy Now
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              ))}
              {loveBundel &&
                loveBundel.map((data, i) => (
                  <div className="col-md-6" key={i}>
                    <div
                      className="packageCard mx-auto text-center"
                      style={{ background: `${data.color_code}` }}
                    >
                      <h1 className="text-light mt-4">{data?.title}</h1>
                      <h1 className="pricePackage">$ {data?.price}</h1>

                      <ul
                        className="text-List fw-bold"
                        style={{ marginBottom: "130px" }}
                      >
                        <li>
                          {data?.love_points === 0 ? (
                            <i className="fa-solid fa-xmark packageColor">
                              {" "}
                              &nbsp;
                            </i>
                          ) : (
                            <i className="fa-solid fa-check packageColor">
                              {" "}
                              &nbsp;
                            </i>
                          )}{" "}
                          Love Points : {data?.love_points}
                        </li>
                      </ul>

                      {/* <button className="btnBuyNow my-4">Buy Now</button> */}

                      {data.price === 0 ? (
                        <button
                          className="btnBuyNow my-4"
                          type="button"
                          onClick={() => handleModelFree(data.id)}
                        >
                          Free
                        </button>
                      ) : (
                        payStatus && (
                          <button
                            className="btnBuyNow my-4"
                            type="button"
                            onClick={() =>
                              handlePackage(
                                data.id,
                                "lovebundel",
                                handelCuntrybasePrice(data.price),
                                data.price
                              )
                            }
                          >
                            Buy Now
                          </button>
                        )
                      )}
                    </div>
                  </div>
                ))}
            </>
          )}
        </div>

        <div className="my-3">
          <h2 className="mt-3 fw-bold activitiesBg p-2 btn w-100 text-center">
            Purchase History
          </h2>

          <Table striped bordered hover variant="dark" responsive>
            <thead>
              <tr>
                <th>#SL</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Package Name</th>
                <th>Price</th>
                <th>Card No</th>
                <th>Holder Name</th>
              </tr>
            </thead>
            <tbody>
              {userWalletHistory.map((data, key) => (
                <tr>
                  <td>{++key}</td>
                  <td>
                    {data.user?.first_name} {data.user?.last_name}
                  </td>
                  <td>
                    {data.user?.phone} <hr /> {data.user?.email}
                  </td>
                  <td>
                    <span
                      className="badge badgeInfo"
                      style={{ backgroundColor: "green" }}
                    >
                      {data.package?.title}
                    </span>
                  </td>
                  <td>{data.package?.price}</td>
                  <td>
                    {data.walletpayment?.card_no
                      ? data.walletpayment?.card_no
                      : "No card no."}
                  </td>
                  <td>
                    {data.walletpayment?.card_holder_name
                      ? data.walletpayment?.card_holder_name
                      : "No holder name"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>

      <MyVerticallyCenteredModal
        show={modalShowPay}
        onHide={() => setModalShowPay(false)}
        event_id={packageId}
        baseFee={baseFee}
        fee={packagePrice}
        event_type={packageType}
        redirectTo="wallet"
      />
    </>
  );
};

export default Packages;
